<template>
  <AuthLayout :mode="mode">
    <MemberActions :mode="mode" />
  </AuthLayout>
</template>

<script>
import AuthLayout from "@A/AuthLayout.vue";
import MemberActions from "@C/MemberActions.vue";

export default {
  name: "EditMember",
  components: {
    AuthLayout,
    MemberActions,
  },
  props: {
    mode: String,
  },
};
</script>
